import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../../../contexts/AuthContext';

function Totals() {
  const [totals, setTotals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
   const { apiBaseUrl } = useAuth();

  // Fetch totals
  const fetchTotals = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiBaseUrl+'/api/transfer-market/admin/totals');
      
      // Sort by price descending and add rank
      const sortedData = (response.data.data || [])
        .map(item => ({
          ...item,
          price: parseFloat(item.price)
        }))
        .sort((a, b) => b.price - a.price)
        .map((item, index) => ({
          ...item,
          rank: index + 1
        }));
      
      setTotals(sortedData);
      setLoading(false);
    } catch (error) {
      console.error('❌ خطا در دریافت مجموع امتیازات:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTotals();
  }, []);

  // Filter based on search (user_id)
  const filteredTotals = totals.filter(item =>
    item.user_id.toString().includes(searchTerm)
  );

  // Get medal color based on rank
  const getMedalColor = (rank) => {
    if (rank === 1) return '#fbbf24';
    if (rank === 2) return '#9ca3af';
    if (rank === 3) return '#fb923c';
    return '#60a5fa';
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-500"></div>
        <span className="text-white mr-3">در حال دریافت اطلاعات...</span>
      </div>
    );
  }

  // Calculate stats
  const totalAmount = totals.reduce((sum, item) => sum + item.price, 0);
  const averageAmount = totals.length > 0 ? totalAmount / totals.length : 0;

  return (
    <div className="space-y-6">
      {/* Header با جستجو */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
        <div>
          <h3 className="text-xl font-bold text-white">مجموع امتیازات کاربران</h3>
          <p className="text-sm text-gray-400 mt-1">رتبه‌بندی بر اساس  ارزش ترنسفر</p>
        </div>
        <div className="relative w-full lg:w-64">
          <input
            type="text"
            placeholder="جستجوی شناسه کاربر..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-gray-700 text-white rounded-lg pl-10 pr-4 py-2 border border-gray-600 focus:border-green-500 focus:outline-none transition-colors"
          />
          <svg className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
        </div>
      </div>

      {/* Stats Summary */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-gradient-to-br from-yellow-600 to-yellow-700 rounded-xl p-5 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-yellow-100 text-sm font-medium">بالاترین مبلغ</p>
              <p className="text-white text-2xl font-black mt-1">
                {totals[0]?.price.toLocaleString() || 0}
              </p>
              <p className="text-yellow-200 text-xs mt-1">تومان</p>
            </div>
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center">
              <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-green-600 to-green-700 rounded-xl p-5 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100 text-sm font-medium">تعداد کاربران</p>
              <p className="text-white text-2xl font-black mt-1">{totals.length}</p>
              <p className="text-green-200 text-xs mt-1">کاربر فعال</p>
            </div>
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center">
              <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-xl p-5 shadow-lg">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100 text-sm font-medium">میانگین مبلغ</p>
              <p className="text-white text-2xl font-black mt-1">
                {Math.round(averageAmount).toLocaleString()}
              </p>
              <p className="text-blue-200 text-xs mt-1">تومان</p>
            </div>
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center">
              <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
          </div>
        </div>
      </div> */}

      {/* Totals Table */}
      <div className="bg-gray-700/30 rounded-xl overflow-hidden border border-gray-600">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-700">
              <tr>
                <th className="px-6 py-4 text-right text-sm font-bold text-gray-300">رتبه</th>
                 <th className="px-6 py-4 text-right text-sm font-bold text-gray-300"> کاربر</th>
                <th className="px-6 py-4 text-right text-sm font-bold text-gray-300">شناسه کاربر</th>
                <th className="px-6 py-4 text-right text-sm font-bold text-gray-300">ارزش ترنسفر</th>
                <th className="px-6 py-4 text-right text-sm font-bold text-gray-300">وضعیت</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-600">
              {filteredTotals.length === 0 ? (
                <tr>
                  <td colSpan="4" className="px-6 py-12 text-center">
                    <p className="text-gray-400">هیچ نتیجه‌ای یافت نشد</p>
                  </td>
                </tr>
              ) : (
                filteredTotals.map((item, index) => (
                  <tr
                    key={item.user_id}
                    className="hover:bg-gray-700/50 transition-colors duration-200"
                    style={{
                      animation: `fadeIn 0.3s ease-out ${index * 0.03}s backwards`
                    }}
                  >
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <div 
                          className="w-9 h-9 rounded-lg flex items-center justify-center shadow-lg font-black text-sm"
                          style={{
                            background: item.rank <= 3 
                              ? `linear-gradient(135deg, ${getMedalColor(item.rank)}, ${getMedalColor(item.rank)}dd)`
                              : 'rgba(75, 85, 99, 0.5)',
                            color: '#fff'
                          }}
                        >
                          {item.rank}
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-lg bg-gray-600 flex items-center justify-center">
                          <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <span className="text-white font-semibold">#{item.user_id}</span>
                      </div>
                    </td>
                     <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-lg bg-gray-600 flex items-center justify-center">
                          <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                          </svg>
                        </div>
                        <span className="text-white font-semibold">#{item.user.username}</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-2">
                        <svg className="w-5 h-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <span className="text-green-400 font-bold text-lg">
                          {item.price.toLocaleString()}
                        </span>
                        <span className="text-gray-400 text-sm">$</span>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      {item.rank === 1 && (
                        <span className="bg-yellow-600 text-white text-xs px-3 py-1.5 rounded-full font-bold">
                          🏆 رتبه اول
                        </span>
                      )}
                      {item.rank === 2 && (
                        <span className="bg-gray-500 text-white text-xs px-3 py-1.5 rounded-full font-bold">
                          🥈 رتبه دوم
                        </span>
                      )}
                      {item.rank === 3 && (
                        <span className="bg-orange-600 text-white text-xs px-3 py-1.5 rounded-full font-bold">
                          🥉 رتبه سوم
                        </span>
                      )}
                      {item.rank > 3 && item.rank <= 10 && (
                        <span className="bg-blue-600 text-white text-xs px-3 py-1.5 rounded-full font-bold">
                          ⭐ Top 10
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default Totals;